export const PINSettingsTypes = {
  SET_NEW_PIN: "set-new-pin",
  UPDATE_PIN: "update-pin",
};
